// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

       //baseUrl: 'https://localhost:7010/api',
       baseUrl: 'https://builtgenix-api-dev.azurewebsites.net/api',


     clarityId: 'rbm32umtfo', // your Clarity project ID

     // Push notification configuration
     webPush: {
       subject: 'mailto:ahutsaluk@builtgenix.com',
       publicKey: 'BM1cL1p8Jtm7kVakZuQ-Dv4A2eA-GXVtLikLcxfn3iULxTPTLkqgLKJoJKdgQIz4kv8DskCVQeDLkUj0S_tpANM',
     },
     turnstileSiteKey: '0x4AAAAAAC2qCSExIUSdiBRy',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
